import {WebPlugin} from "@capacitor/core";
import CleverTap from "clevertap-web-sdk";

interface TrackEventOptions {
  eventName: string;
  properties?: Record<string, any>;
}

export class ClevertapPlugin extends WebPlugin {
  clevertap: any;

  /**
   * This is a web plugin for the Clevertap analytics service.
   * It is used to track events in the web app with clevertap-web-sdk.
   * In the native app, we use the Clevertap SDK to track events with a plugin too.
   */
  constructor() {
    // @ts-expect-error - installed @capacitor/core WebPlugin typings declare a zero-arg
    // constructor, but the runtime constructor accepts (and safely ignores) a config object.
    super({
      name: "AnalyticsTrackerPlugin",
      platforms: ["web"]
    });

    this.clevertap = CleverTap;
    this.clevertap.init(process.env.REACT_APP_CLEVERTAP_ACCOUNT_ID, "eu1");
    this.clevertap.spa = true;
  }

  async initUser(userId: string) {
    await this.clevertap.onUserLogin.push({
      Site: {
        Identity: userId
      }
    });
  }

  async trackEvent(options: TrackEventOptions) {
    const properties = {
      ...(options.properties || {}),
      source: options.properties?.source ?? "webapp"
    };
    await this.clevertap.event.push(options.eventName, properties);
  }
}
